import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {STEPPER_GLOBAL_OPTIONS} from "@angular/cdk/stepper";


@Component({
  selector: 'app-usage-hints',
  templateUrl: './usage-hints.component.html',
  styleUrls: ['./usage-hints.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {displayDefaultIndicatorType: false}
  }]
})
export class UsageHintsComponent implements OnInit {

  @Output()
  onSkipClick = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  closeStepper() {
    this.onSkipClick.emit(false);
  }

}
